import React, { useCallback, useEffect, useState } from 'react';
import { unwrapResult } from '@reduxjs/toolkit';
import { useHistory, useParams } from 'react-router';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { toast } from 'react-toastify';

import '../CreateCampaign/createCampaign.scss';
import CustomButton from '../../../uiKit/Button/CustomButton';
import Title from '../../../uiKit/Title/Title';

import Header from '../../../components/Header/header';
import CampaignMessages from './HelperComponents/campaignMessages';
import CampaignsInfos from './HelperComponents/campaignInfos';

import {
    clearCampaigns,
    getCampaignDraft,
    launchCampaignDraft,
    updateCampaignDraft,
} from '../../../redux/state/campaignSlice';
import { setTabType } from '../../../redux/state/communitySlice';

const DraftCampaign = () => {

    const isLoading = useSelector(state => state.campaign.isLoading.launchCampaignDraft, shallowEqual);
    const isLoadingDraft = useSelector(state => state.campaign.isLoading.updateCampaignDraft, shallowEqual);
    const isLoadingGetDraft = useSelector(state => state.campaign.isLoading.getCampaignDraft, shallowEqual);

    const history = useHistory();
    const dispatch = useDispatch();
    const { campaignId } = useParams();
    const communityId = useSelector(state => state.community.community.id, shallowEqual);

    const [draftMessages, setDraftMessages] = useState(null);
    const [messages, setMessages] = useState(null);
    const [excludedMembers, setExcludedMembers] = useState([]);

    const [editedCampaign, setEditedCampaign] = useState({
        id: null,
        name: '',
        campaignTypeId: 0,
        recipient: {
            userId: null,
            fullName: null
        },
        amount: 0,
        recipientId: null,
        description: '',
        excludedMembers: [],
        campaignUrgencyType: 1,
    });

    useEffect(() => {
        if (!!communityId && !!campaignId) {
            dispatch(getCampaignDraft({ communityId, campaignId }))
                .then(unwrapResult)
                .then(response => {
                    const {
                        id,
                        name,
                        campaignTypeId,
                        recipient,
                        recipientId,
                        amount,
                        description,
                        messages,
                        excludedMembers,
                        campaignUrgencyType
                    } = response.campaign;
                    const ids = excludedMembers.map(member => member.userId);
                    const campaignUrgencyTypeId = campaignUrgencyType.id;
                    setEditedCampaign({
                        id,
                        name,
                        campaignTypeId,
                        recipient,
                        amount,
                        recipientId,
                        description,
                        campaignUrgencyType: campaignUrgencyTypeId,
                        excludedMembers: ids
                    });
                    setExcludedMembers(excludedMembers);
                    setDraftMessages(messages);
                })
                .catch(({ title }) => toast.info(title))
        }
    }, [communityId, campaignId, dispatch])

    const saveHandler = () => {

        const data = { ...editedCampaign, communityId, messages }
        dispatch(launchCampaignDraft({
            communityId,
            campaignId,
            data
        }))
            .then(unwrapResult)
            .then((res) => {
                dispatch(clearCampaigns());
                setTimeout(() => {
                    history.push(`/campaigns/campaign/active/${communityId}/${res.campaign.id}`)
                }, [1000])
            })
            .catch(({ title }) => {
                window.scrollTo(0, 0);
                toast.info(`Launching draft failed: ${title}`)
            })
    }

    const saveDraftHandler = () => {

        const data = { ...editedCampaign, communityId, messages }

        dispatch(updateCampaignDraft({
            communityId,
            campaignId,
            data
        }))
            .then(unwrapResult)
            .then(() => {
                dispatch(setTabType(6));
                history.push(`/communities/community/${communityId}`)
            })
            .catch(({ title }) => {
                window.scrollTo(0, 0);
                toast.info(`Saving draft failed: ${title}`)
            })
    }

    const updateMessages = useCallback((newMessages) => setMessages(newMessages), [])

    return (
        <>
            <Header title='Drafts' onClick={() => {
                dispatch(setTabType(6));
                history.push(`/communities/community/${communityId}`)
            }} />
            <div className='campaignTitle'>
                <Title
                    text='Create a campaign'
                    fontSize={32}
                    lineHeight={40}
                />
            </div>
            <div className='titleInputWrapper'>
                <CampaignsInfos
                    campaign={editedCampaign}
                    setCampaign={setEditedCampaign}
                    excluded={excludedMembers}
                />
                <div className='divider' style={{ marginBottom: '8px' }} />
                <CampaignMessages
                    messages={draftMessages}
                    updateMessages={updateMessages}
                    isLoading={isLoadingGetDraft}
                />
                <div className='divider' />
                <div className='createCampaignButtons' >
                    <CustomButton
                        title='Launch'
                        style={{ marginBottom: '16px' }}
                        classNames='mr16to0'
                        onClick={saveHandler}
                        disabled={isLoading}
                        loading={isLoading}
                    />
                    <CustomButton
                        isWhite
                        title='Save as Draft'
                        onClick={saveDraftHandler}
                        disabled={isLoadingDraft}
                        loading={isLoadingDraft}
                    />
                </div>
            </div >
        </>
    )

}

export default DraftCampaign;